<div class="d-flex justify-content-center mt-2">
    <mat-card class="login-card">
        <mat-card-header>
            <mat-card-title>Login to the CSI Admin Portal</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <button mat-button style="padding: 1rem;" (click)="onSignIn()">
                <mat-icon style="width: 50px; height:30px" svgIcon="logo"></mat-icon> Login With Google
            </button>
        </mat-card-content>
    </mat-card>
</div>

@if (isLoggingIn) {
<div class="loading-shade">
    @if (isLoggingIn) {
    <mat-spinner></mat-spinner>
    }
</div>
}